/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerCompanySubItems {
  CustomerInformation = 0,
  Actor = 1,
  MailRecipient = 2,
}
